import React, { useState, useEffect } from "react";
import ModalSearchUser from "../../components/empresa_uno_comp/ModalSearchUser";
import { toast } from "react-toastify";
import { ApiService } from "../ApiService";

export const ModalNuevoUsuario = ({ isOpen, onClose, onUserAdded, current_branch, roles, cargos, keyBranch }) => {
	if (current_branch == null) onClose();

	const [selectedRole, setSelectedRole] = useState("");
	const [selectedCargo, setSelectedCargo] = useState("");
	const [selectedUserName, setSelectedUserName] = useState(""); // Nombre del usuario seleccionado
	const [selectedUserAuthCode, setSelectedUserAuthCode] = useState(""); // authCode del usuario seleccionado
	const [isModalOpen, setModalOpen] = useState(false);

	// Estados para manejar errores
	const [selectedUserError, setSelectedUserError] = useState(false);
	const [selectedRoleError, setSelectedRoleError] = useState(false);
	const [selectedCargoError, setSelectedCargoError] = useState(false);

	const handleUserSelection = (user) => {
		setSelectedUserName(user.fullName);
		setSelectedUserAuthCode(user.authCode);
		setSelectedUserError(false); // Eliminar error al seleccionar usuario
		setModalOpen(false); // Cerrar el modal de búsqueda
	};

	const handleSaveUser = async () => {
		// Validar campos requeridos
		let hasError = false;

		if (!selectedUserAuthCode) {
			setSelectedUserError(true);
			toast.error("El usuario es obligatorio", { position: "top-right" });
			hasError = true;
		}

		if (!selectedRole) {
			setSelectedRoleError(true);
			toast.error("El rol es obligatorio", { position: "top-right" });
			hasError = true;
		}

		if (!selectedCargo) {
			setSelectedCargoError(true);
			toast.error("El cargo es obligatorio", { position: "top-right" });
			hasError = true;
		}

		if (hasError) {
			return;
		}

		// Preparar datos para la solicitud
		const payload = {
			user: selectedUserAuthCode,
			role: selectedRole,
			jobPosition: selectedCargo,
			dateStarted: new Date().toISOString().split("T")[0], // Fecha de hoy en formato YYYY-MM-DD
		};

		// Cerrar el modal inmediatamente
		onClose();

		try {
			const url = `api/company/user/add?key_branch=${keyBranch}`;
			const options = {
				method: "POST",
				body: JSON.stringify(payload),
			};

			const response = await ApiService.fetchData(url, options);

			if (response) {
				toast.success("Usuario creado exitosamente.", { position: "top-right" });
				onUserAdded(); // Actualiza la lista de usuarios
			} else {
				toast.error("No se pudo crear el usuario.", { position: "top-right" });
			}
		} catch (error) {
			console.error("Error al crear usuario:", error);
			toast.error("Error al conectar con el servidor.", { position: "top-right" });
		}
	};

	if (!isOpen) return null;

	return (
		<div className="modal-overlay-addUser">
			<div className="modal-content-addUser">
				<div className="modal-header-addUser">
					<h2>Agregar Usuario</h2>
					<button className="close-modal-btn-addUser" onClick={onClose}>
						✖
					</button>
				</div>

				<form className="modal-form-addUser">
					{/* Lado izquierdo */}
					<div className="form-column-addUser">
						<div className="form-group" style={{ display: "flex", flexDirection: "column" }}>
							<label htmlFor="usuario">Usuario</label>
							<div style={{ display: "flex", flexDirection: "row" }}>
								<input
									className={`modal-input-old ${selectedUserError ? "input-error" : ""}`}
									type="text"
									readOnly
									value={selectedUserName}
									placeholder="Seleccione usuario en el botón"
								/>
								<button
									style={{ marginTop: "0px", width: "40px", marginLeft: "5px" }}
									className="btn-add-section-product"
									type="button"
									onClick={() => setModalOpen(true)}>
									<span>+</span>
								</button>
							</div>
						</div>
						<div className="form-group">
							<label htmlFor="rol">Rol</label>
							<select
								className={`modal-input-old ${selectedRoleError ? "input-error" : ""}`}
								id="rol"
								value={selectedRole}
								onChange={(e) => {
									setSelectedRole(e.target.value);
									setSelectedRoleError(false); // Quitar error al seleccionar
								}}>
								<option value="" disabled>
									Seleccione un rol
								</option>
								{roles.map((role) => (
									<option key={role.authCode} value={role.authCode}>
										{role.name}
									</option>
								))}
							</select>
						</div>
					</div>

					{/* Lado derecho */}
					<div className="form-column-addUser">
						<div className="form-group">
							<label htmlFor="cargo">Cargo</label>
							<select
								className={`modal-input-old ${selectedCargoError ? "input-error" : ""}`}
								id="cargo"
								value={selectedCargo}
								onChange={(e) => {
									setSelectedCargo(e.target.value);
									setSelectedCargoError(false); // Quitar error al seleccionar
								}}>
								<option value="" disabled>
									Seleccione un cargo
								</option>
								{cargos.map((cargo) => (
									<option key={cargo.key_cargo} value={cargo.key_cargo}>
										{cargo.name}
									</option>
								))}
							</select>
						</div>
					</div>
				</form>

				<ModalSearchUser
					isOpen={isModalOpen}
					onClose={() => setModalOpen(false)}
					onUserSelect={handleUserSelection}
				/>

				<div className="modal-footer">
					<button className="cancel-button-product" onClick={onClose}>
						Cancelar
					</button>
					<button type="button" className="save-button" onClick={handleSaveUser}>
						Guardar
					</button>
				</div>
			</div>
		</div>
	);
};

export default ModalNuevoUsuario;
